import { SESSION_DATA } from '../helpers/storeHelper';

export enum LOADER_SCREEN_ACTION {
  INCREMENT = 'INCREMENT',
  DECREMENT = 'DECREMENT',
}

export enum API_STATUS_TYPES {
  SHOW_ERROR_SCREEN = 'showErrorScreen',
  RESET_SHOW_ERROR_SCREEN = 'resetShowErrorScreen',
  LOADER_SCREEN_COUNTER = 'loaderScreenCounter',
}

export enum PKCE_REDUCER_ACTION {
  INITIALIZE = 'INITIALIZE',
  REFRESH = 'REFRESH',
}

/**
 * Below session storage keys represent value of respective keys which are needed to be excluded from encryption/decryption
 */
export const EXCLUSIVE_SECURE_SESSION_STORAGE_KEYS = SESSION_DATA && [
  SESSION_DATA?.MEMBER_ID,
  SESSION_DATA?.M_ID,
  SESSION_DATA?.MPP_ID,
  SESSION_DATA?.ACCESS_TOKEN,
  SESSION_DATA?.ID_TOKEN,
  SESSION_DATA?.REFRESH_TOKEN,
  SESSION_DATA?.PKCE_VERIFIER,
  SESSION_DATA?.PKCE_STATE,
  SESSION_DATA?.PAYMENT_FUNDING_ACCOUNT_TOKEN,
  SESSION_DATA?.SELECTED_WALLET_FUNDING_ACCOUNT_TOKEN,
  SESSION_DATA?.WALLET_FUNDING_ACCOUNT_TOKEN,
  SESSION_DATA?.CAID,
  SESSION_DATA?.LOB,
  SESSION_DATA?.IS_NMA_USER,
  SESSION_DATA?.IS_BROKER_USER,
];
